import { render, staticRenderFns } from "./prdOrcamento.vue?vue&type=template&id=ebb37082&scoped=true&"
import script from "./prdOrcamento.vue?vue&type=script&lang=js&"
export * from "./prdOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./prdOrcamento.vue?vue&type=style&index=0&id=ebb37082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb37082",
  null
  
)

export default component.exports